import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { signup as firebaseSignup } from './services/authService';
import { signInWithGoogle } from './services/authService';
function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await firebaseSignup(name, email, password); // user: { id, name, email }
      login(data); // update AuthContext

      setLoading(false);
      navigate(`/main/${data.name}`);
    } catch (err) {
      console.error('Signup error:', err);
      setLoading(false);
      setError(err.message || 'Signup failed');
    }
  };
  const handleGoogleSignIn = async () => {
  setError('');
  setLoading(true);

  try {
    const data = await signInWithGoogle();
    // Use the login function from AuthContext to update state
    login(data); 
    // Redirect upon success
    navigate(`/main/${data.name}`); 

  } catch (err) {
    console.error('Google Sign-In error:', err);
    setLoading(false);
    setError(err.message || 'Google Sign-In failed.');
  }
};

  return (
    <div className="auth-bg">
      <div className="auth-card-neon">
        <h2 className="auth-title">Create your account</h2>
       
       <button 
  type="button"
  onClick={handleGoogleSignIn}  style={{alignContent: 'center',marginLeft: '90px'}}
  disabled={loading}
>
    <div className="auth-switch-link">Sign up with Google</div>
</button>
<div className="auth-separator" style={{ margin: '20px 0', textAlign: 'center', fontWeight: 'bold' }}>OR</div>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-group">
            <span className="auth-input-icon">👤</span>
            <input className="auth-input" placeholder="Name" value={name} onChange={e => setName(e.target.value)} required autoFocus />
          </div>
          <div className="auth-input-group">
            <span className="auth-input-icon">📧</span>
            <input className="auth-input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="auth-input-group">
            <span className="auth-input-icon">🔒</span>
            <input className="auth-input" type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            <span className="auth-input-icon auth-eye" onClick={() => setShowPassword(v => !v)} style={{ cursor: 'pointer' }}>{showPassword ? '🙈' : '👁️'}</span>
          </div>
          <button className="auth-btn" type="submit" disabled={loading}>{loading ? 'Signing up...' : 'Sign Up'}</button>
        </form>
        <div className="auth-switch-text">
          Already have an account?{' '}
          <a href="/login" className="auth-switch-link">Login</a>
        </div>
      </div>
    </div>
  );
}
export default Signup;